
import { defineComponent } from 'vue';
import Alert from '~/components/Alerts/Alert.vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import { AutopayDetails } from '@/interfaces/loan';
import { PaymentOptions } from '@/interfaces/payment-options';

export default defineComponent({
  name: 'AutopayActive',

  components: {
    Alert,
    CustomButton,
  },

  computed: {
    autopayDetails(): AutopayDetails {
      return this.$store.getters['Loan/getAutopayDetails'];
    },

    autopayPaymentMethod() {
      return this.autopayDetails.payment_method_details;
    },

    paymentMethodType(): PaymentOptions {
      return this.autopayPaymentMethod.payment_method_type;
    },
  },
});
